// import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'

class Strategy extends AssistClasses.SingleStepStrategy {
  constructor (cxt, repo) {
    super(cxt, 'LINKS')
  }
  getTypeName () {
    return `Ссылка`
  }
  createModel () {
    return {}
  }
  updateScheme (scheme) {
    return [
      {
        fieldType: 'v-text-field',
        label: 'Ссылка',
        name: 'link',
        events: {
          'input': (e) => this.onLinkChange(e)
        },
        hint: 'Укажите ссылку на страницу',
        grow: true,
        size: {sm12: true, xs12: true}
      },
      {
        fieldType: 'v-text-field',
        label: 'Наименование',
        name: 'name',
        hint: '',
        grow: true,
        size: {sm8: true, xs8: true}
      },
      {
        fieldType: 'v-select',
        label: 'Тип ссылки',
        itemValue: 'value',
        itemText: 'text',
        items: (model, field) => {
          return this.getLinkTypes()
        },
        name: 'type',
        events: {
          'change': (e) => this.onTypeChange(e)
        },
        shrink: false,
        size: {sm4: true, xs4: true}
      },
      {
        fieldType: 'v-btn',
        slot: 'Проверить',
        events: {'click': () => this.openLink()},
        shrink: true,
        size: {sm4: true, xs4: true}
      }
    ]
  }
  getLinkTypes () {
    const linkTypes = [
      {value: 'as', text: 'Атлант-Смарт', rule: (v) => v && /atlant-smart\.ru/i.test(v), url: 'https://atlant-smart.ru/', img: 'static/img/icons/favicon-32x32.png'},
      {value: 'vk', text: 'VKontakt', rule: (v) => v && /vk\.com/i.test(v), url: 'https://vk.com/[id]', img: 'static/img/lnks/vk.png'},
      {value: 'fb', text: 'Facebook', rule: (v) => v && /facebook\.com/i.test(v), url: 'https://facebook.com/[id]', img: 'static/img/lnks/fb.png'},
      {value: 'ok', text: 'Одноклассники', rule: (v) => v && /ok\.ru/i.test(v), url: 'https://ok.ru/profile/[id]', img: 'static/img/lnks/ok.svg'},
      {value: 'wa', text: 'WhatsApp', rule: (v) => v && /wa\.me/i.test(v), url: 'https://wa.me/[id]', img: 'static/img/lnks/wa.png'},
      {value: 'vb', text: 'Viber', rule: (v) => v && /viber:/i.test(v), url: 'viber://add?number=[id]', img: 'static/img/lnks/vb.png'},
      {value: 'tg', text: 'Telegram', rule: (v) => v && /t\.me/i.test(v), url: 'https://t.me/[id]', img: 'static/img/lnks/tg.svg'},
      {value: 'sk', text: 'Skype', rule: (v) => v && /skype:/i.test(v), url: 'skype:[id]', img: 'static/img/lnks/sk.ico'},
      {value: 'ln', text: 'LinkedInn', rule: (v) => v && /linkedin\.com/i.test(v), url: 'https://www.linkedin.com/in/[id]', img: 'static/img/lnks/ln.png'},
      {value: 'tw', text: 'Twitter', rule: (v) => v && /twitter\.com/i.test(v), url: 'https://twitter.com/[id]', img: 'static/img/lnks/tw.png'},
      {value: 'in', text: 'Instagramm', rule: (v) => v && /instagram\.com/i.test(v), url: 'https://instagram.com/[id]', img: 'static/img/lnks/in.png'},
      {value: 'wb', text: 'Веб сайт', rule: null, url: 'https://[id]', img: 'static/img/lnks/public.png'}
    ]
    return linkTypes
  }
  getLinkTypesByValue () {
    let map = new Map()
    let order = 0
    this.getLinkTypes().forEach(i => {
      i['order'] = order++
      map.set(i.value, i)
    })
    return map
  }
  onLinkChange (v) {
    let arr = this.getLinkTypes().filter(i => i.rule && i.rule(v))
    let type = arr && arr.length > 0 && arr[0]
    if (type) {
      let model = this.getModel()
      model['type'] = type.value
      // model['name'] = type.text
      // model['img'] = type.img
    }
  }
  isDefault (model) {
    let arr = this.getLinkTypes().filter(i => (i.url.replace(/\[id\]/, model['name'] === model.link)))
    return arr && arr.length > 0
  }
  onTypeChange (v) {
    let arr = this.getLinkTypes().filter(i => i.value === v)
    let type = arr && arr.length > 0 && arr[0]
    if (type) {
      let model = this.getModel()
      let def = this.isDefault(model)
      model['link'] = model['link'] && !def ? model['link'] : type.url.replace(/\[id\]/, model['name'])
    }
  }
  viewChipsList (repo) {
    let chips = []
    let types = this.getLinkTypesByValue()
    repo.getItems().forEach(item => {
      let type = types.get(item.type)
      chips.push(
        {
          value: item.link,
          text: item.name ? item.name : type.text,
          img: type ? type.img : null,
          hint: item.link,
          error: null,
          order: type.order
        })
    })
    return chips.sort((a, b) => a.order - b.order)
  }
  setName (model) {
    console.log('setName', model)
    if (!model.name && model.link && model.type) {
      let type = this.getLinkTypesByValue().get(model.type)
      let name = model.link
      let ps = type.url.split('[id]')
      for (const p of ps) {
        name = name.replace(p, '')
      }
      model.name = name
    }
  }
  openLink () {
    let model = this.getModel()
    this.setName(model)
    this.context.$store.dispatch('openLocation', model.link)
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy
}



// WEBPACK FOOTER //
// ./src/components/people/ContactLinks.js